export const isArrayEmpty = (item: readonly any[]): boolean => {
  if (!item) {
    return true;
  }

  return (item as any[]).length === 0;
};
